<ng-template #contentTextTemplateDefault let-item="item">
  {{item.label | translate}}
</ng-template>
<ng-template #contentIconLeftTextTemplateDefault let-item="item">
  <mat-icon>{{item.icon}}</mat-icon>{{item.label | translate}}
</ng-template>
<ng-template #contentIconRightTextTemplateDefault let-item="item">
  {{item.label | translate}}<mat-icon>{{item.icon}}</mat-icon>
</ng-template>
<button matTooltip="{{titleText | translate}}" matTooltipClass="mo-tooltip" class="{{type}} {{color}}" [ngClass]="{'disabled':disabled,'selected':toggle && isSelected}">
  <ng-template *ngTemplateOutlet="(contentTemplate ?? getTemplate(contentTextTemplateDefault,contentIconLeftTextTemplateDefault,contentIconRightTextTemplateDefault)); context{item: this}"></ng-template>
</button>
